/* eslint-disable import/no-unresolved */
import React from 'react';

import FeatureCheck from '@components/common/FeatureCheck';

const ErrorConfig = () => {
  return <FeatureCheck featureName="App Experience" />;
};

export default ErrorConfig;
